/**
 * rcmUiRcmCountryRepository
 */
angular.module('rcm-ui').service(
    'rcmUiRcmCountryRepository',
    [
        'pipeRatApiRepositoryPromiseService',
        function (
            pipeRatApiRepositoryPromiseService
        ) {
            return pipeRatApiRepositoryPromiseService.getNewRepository(
                '/api/resource/rcm-country',
                'rcmUiRcmCountryRepository'
            );
        },
    ]
);
